import pathRouts from "../../../enums/pathRoute";
import { appendQueryParams } from "../../../utils/utils";

export const getDelayNavigateUrl = ({ link, reloadOpener = 0, ga }) => {
    const loadingPageUrl = `${window.location.origin}${window.config.baseUrl}/${pathRouts.DELAYNAVIGATE}/ENCODED_${btoa(encodeURIComponent(link))}/${Number(reloadOpener)}`;
    return appendQueryParams(loadingPageUrl, {
        gaSection: ga?.section,
        gaSectionValue: ga?.sectionValue,
    });
};

export const getNavigateUrl = ({ link, checkAuth, showLoadingPage, ga }) => {
    if (!link) {
        return null;
    }

    const wrapWithLogin = (nextUrl) => `${window.config.baseApiUrl}/auth/eduidp?next=${encodeURIComponent(nextUrl)}`;

    if (showLoadingPage) {
        const urlWithAnalytics = getDelayNavigateUrl({ link, reloadOpener: Number(checkAuth), ga });
        return checkAuth ? wrapWithLogin(urlWithAnalytics) : urlWithAnalytics;
    }

    if (!checkAuth) {
        return link;
    }

    const nextUrl = link.startsWith("http")
        ? link
        : `${window.location.origin}${window.config.baseUrl || "/"}${link}`;

    return wrapWithLogin(nextUrl);
};

export const navigateToUrl = ({ event, url, finalTarget, navigate, onClick, state }) => {
    onClick?.(event);
    if (event?.defaultPrevented || !url)
        return;

    if (url?.startsWith("http")) {
        window.open(url, finalTarget ?? "_blank");
        return;
    }
    navigate(url, state ? { state } : undefined);
};
